// Small shared formatters for the sale sections. Dates are rendered in a FIXED
// time zone (Europe/Sofia is not used: the sale runs on CET, 06:00 CET = 05:00Z)
// so the SSR HTML and the client's first render agree for every visitor.
import { msOf } from '../../../lib/saleCampaign'

const DAY_FMT = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Europe/Berlin' })
const TIME_FMT = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Europe/Berlin' })
const RANGE_FMT = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', timeZone: 'Europe/Berlin' })

/** "Sun 22 Nov" */
export const formatSaleDay = (v) => DAY_FMT.format(new Date(msOf(v)))

/** "Sun 22 Nov, 06:00 CET" */
export const formatSaleMoment = (v) => `${formatSaleDay(v)}, ${TIME_FMT.format(new Date(msOf(v)))} CET`

/**
 * "19 November - 3 December". The campaign `end` is the moment the sale stops
 * (e.g. 4 Dec 06:00 CET), so the last full day shown is the day before.
 */
export const formatSaleRange = (start, end) => {
  const lastDay = msOf(end) - 6 * 3600000 - 1
  return `${RANGE_FMT.format(new Date(msOf(start)))} - ${RANGE_FMT.format(new Date(lastDay))}`
}

/** "$549" / "€509" / "AU$749" from a backend price object. */
export const formatMoney = (priceObj) => {
  if (!priceObj || !Number.isFinite(priceObj.priceCents)) return null
  const value = priceObj.priceCents / 100
  const v = Number.isInteger(value) ? value.toLocaleString('en-US') : value.toFixed(2)
  switch (priceObj.currency) {
    case 'EUR': return `€${v}`
    case 'USD': return `$${v}`
    case 'AUD': return `AU$${v}`
    default: return `${v} ${priceObj.currency || ''}`.trim()
  }
}

export const itemTypeOf = (item) =>
  item && (typeof item.itemType === 'object' && item.itemType ? item.itemType.itemType : item.itemType || item.type)

/** regular (strike-through) price object for an offer */
export const regularPriceOf = (item) => (item && (item.regularPrice || item.price)) || null

/** what the customer pays */
export const salePriceOf = (item) => (item && (item.discountPrice || item.price)) || null

export const savingOf = (item) => {
  const r = regularPriceOf(item)
  const s = salePriceOf(item)
  if (!r || !s || !(s.priceCents < r.priceCents)) return null
  return {
    amount: { priceCents: r.priceCents - s.priceCents, currency: s.currency || r.currency },
    percent: Math.round((1 - s.priceCents / r.priceCents) * 100),
  }
}

/** shop-card main image descriptor, same choice as Shop renderShopItem */
export const mainImageOf = (item) => {
  if (!item) return null
  if (item.imageOverride) return item.imageOverride
  if (Array.isArray(item.galleryImages) && item.galleryImages.length) return item.galleryImages[0]
  return item.imageUrl || null
}
